module.exports = __webpack_public_path__ + "img/pt_seguroportatil.218981b0.png";